// src/common-components/HeaderSpacer/HeaderSpacer.tsx
import React from 'react';

export function useHeaderHeight(): number {
  const [height, setHeight] = React.useState(70);
  React.useEffect(() => {
    const getHeight = () => {
      const desktop = document.querySelector<HTMLElement>('.container-menu-desktop');
      if (desktop && desktop.offsetParent !== null) return desktop.getBoundingClientRect().height;
      const mobile = document.querySelector<HTMLElement>('.wrap-header-mobile');
      if (mobile) return mobile.getBoundingClientRect().height;
      return 70;
    };
    const update = () => setHeight(getHeight());
    const t = setTimeout(update, 60);
    const ro = new ResizeObserver(update);
    const d = document.querySelector<HTMLElement>('.container-menu-desktop');
    const m = document.querySelector<HTMLElement>('.wrap-header-mobile');
    if (d) ro.observe(d);
    if (m) ro.observe(m);
    return () => { clearTimeout(t); ro.disconnect(); };
  }, []);
  return height;
}

const HeaderSpacer: React.FC = () => {
  const height = useHeaderHeight();
  return <div style={{ height, flexShrink: 0, transition: 'height 0.4s cubic-bezier(0.16,1,0.3,1)' }} aria-hidden="true" />;
};

export default HeaderSpacer;